import styled from 'styled-components';

export const PopupHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem;
  height: 1.625rem;
`;

export const PopupHeaderStart = styled.div`
  height: 100%;
  width: 1.625rem;
  background: ${({ theme, $background }) => $background || theme.menuTitle};
`;

export const PopupHeaderButtonSeparator = styled.div`
  height: 100%;
  width: 0.5rem;
  background: ${({ theme, $background }) => $background || theme.menuTitle};
`;

export const PopupHeaderEnd = styled.div`
  height: 100%;
  background: ${({ theme, $background }) => $background || theme.menuTitle};
  flex-grow: 1;
`;

export const PopupHeaderTitle = styled.div`
  padding-top: 6px;
  background: transparent;
  color: white;
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-size: 1.625rem;
  font-weight: 400;
`;

export const PopupHeaderButton = styled.div`
  cursor: pointer;
  min-width: 1.625rem;
  min-height: 1.625rem;
  max-width: 1.625rem;
  max-height: 1.625rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${({ theme, $background }) => $background || theme.menuTitle};

  &:hover {
    opacity: 0.6;
  }
`;
